const IMAGE_CONTENT_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/bmp",
  "image/avif",
]);

const VIDEO_CONTENT_TYPES = new Set([
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video/quicktime",
]);

const AUDIO_CONTENT_TYPES = new Set([
  "audio/mpeg",
  "audio/mp4",
  "audio/ogg",
  "audio/wav",
  "audio/webm",
]);

const EXTENSION_KINDS = {
  png: "image",
  jpg: "image",
  jpeg: "image",
  gif: "image",
  webp: "image",
  bmp: "image",
  avif: "image",
  mp4: "video",
  webm: "video",
  mov: "video",
  ogv: "video",
  mp3: "audio",
  m4a: "audio",
  wav: "audio",
  oga: "audio",
  pdf: "pdf",
};

export const UNAVAILABLE_REASON_LABELS = {
  too_large: "Supera el tamaño máximo",
  download_failed: "No se pudo descargar",
  unsupported: "Archivo en la nube, sin contenido descargable",
};

/**
 * Clasifica un adjunto según cómo se puede mostrar en el navegador.
 *
 * Usa los mismos tipos que el back sirve inline; los demás se descargan. Si
 * el tipo falta o es el genérico (application/octet-stream), lo deduce de la
 * extensión del nombre.
 *
 * @param {{content_type?: string, name?: string}} attachment Adjunto.
 * @returns {"image" | "video" | "audio" | "pdf" | "file"} Tipo de vista.
 */
const GENERIC_CONTENT_TYPE = "application/octet-stream";

export const getAttachmentKind = (attachment = {}) => {
  const contentType = (attachment.content_type || "").toLowerCase();

  if (IMAGE_CONTENT_TYPES.has(contentType)) return "image";
  if (VIDEO_CONTENT_TYPES.has(contentType)) return "video";
  if (AUDIO_CONTENT_TYPES.has(contentType)) return "audio";
  if (contentType === "application/pdf") return "pdf";
  if (contentType && contentType !== GENERIC_CONTENT_TYPE) return "file";

  const extension = (attachment.name || "").split(".").pop().toLowerCase();
  return EXTENSION_KINDS[extension] || "file";
};

export const isInboundAttachment = (attachment = {}) =>
  attachment.source === "inbound";

export const isAttachmentAvailable = (attachment = {}) =>
  attachment.available !== false && Boolean(attachment.file);
